import { render, staticRenderFns } from "./select-table-data.vue?vue&type=template&id=36f22ce0&"
import script from "./select-table-data.vue?vue&type=script&lang=ts&"
export * from "./select-table-data.vue?vue&type=script&lang=ts&"
import style0 from "./select-table-data.vue?vue&type=style&index=0&id=36f22ce0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports